import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-window",
  "use": "icon-window-usage",
  "viewBox": "0 0 168 168",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 168 168\" id=\"icon-window\">\n    <path class=\"cls-1\" d=\"M86.12,21.39V77.82h74.61V9Zm0,125.43L160.73,159V90.22H86.12ZM7.27,77.8H70.34V23.44L7.27,33.89Zm0,56.72,63.07,10.27V90.22H7.27Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol